
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/ios",
      function () {
        return require("private-next-pages/docs/link/ios/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/ios"])
      });
    }
  